import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AppProvider } from './contexts/app.context';
import { APP_BASE_PATH } from './config/appPath';

if (window.location.pathname === '/') {
  window.location.replace(`${APP_BASE_PATH}${window.location.search}${window.location.hash}`);
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <BrowserRouter basename={APP_BASE_PATH}>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>,
  );
}
